import { isFuture } from "date-fns";

export const FIELD_REQUIRED_MSG = "This field is required";

export const isFutureDate = (date: Date) => isFuture(date);
